import { Injectable } from '@angular/core';
import OneSignal, { LogLevel } from "onesignal-cordova-plugin";
import { Router } from "@angular/router";
import { AuthService } from './auth.service';
import { ResponseAPI, User, UserType } from 'src/models/user.model';
import { Platform } from '@ionic/angular';
import { Events } from './events-service.service';
import { SignalRService } from './signalr.service';
import { HubConnectionState } from '@microsoft/signalr';
import { CrudService } from './crud.service';
import { Capacitor } from '@capacitor/core';

@Injectable({
    providedIn: "root",
})
export class OneSignalService {
    user: User;

    constructor(
        private router: Router,
        private auth: AuthService,
        private events: Events,
        private platform: Platform,
        private signalRService: SignalRService,
        private _crudService: CrudService) {
        this.user = this.auth.user;
    }

    public clearAll() {
        if (!Capacitor.isNativePlatform()) {
            return;
        }
        OneSignal.Notifications.clearAll();

    }

    public requestPermissionAndEnableOneSignal() {
        if (!Capacitor.isNativePlatform()) {
            return;
        }
        console.log(this.user);
        OneSignal.setConsentRequired(true);
        OneSignal.setConsentGiven(true);
        OneSignal.initialize(this.user.userType === UserType.Driver ? "0d7998e3-86c8-427b-ae49-c4f48110e9b5" : "92f47163-b63a-4e1d-a8f7-51f3bf6ae21e");
        OneSignal.User.addEmail(this.user.email);
        OneSignal.User.addSms(this.user.cellPhone);
        console.log("Requesting permission");
        console.log("Platform", this.platform.platforms());

        OneSignal.Notifications.getPermissionAsync().then((hasPermission) => {
            console.log("Permission status", hasPermission);
            if (hasPermission) {
                this.startPush();
            }
            else {
                OneSignal.Notifications.requestPermission(false).then((permissionRequestAllowed) => {
                    console.log("Permission status", permissionRequestAllowed);
                    if (permissionRequestAllowed) {
                        this.startPush();
                    }
                }).catch((e) => {
                    console.error("Error requesting permission", e);
                });
            }
        }
        ).catch((e) => {
            console.error("Error getting permission", e);
        });

        OneSignal.Notifications.requestPermission(false).then((permissionRequestAllowed) => {
            console.log("Permission status", permissionRequestAllowed);
            if (permissionRequestAllowed) {
                this.startPush();
            }
        }).catch((e) => {
            console.error("Error requesting permission", e);
        });
        OneSignal.Notifications.addEventListener("permissionChange", (granted) => {
            console.log("Permission change", granted);
            if (granted) {
                this.startPush();
            }
        });

    }

    private startPush() {
        console.log("Starting push");
        OneSignal.login(this.user.id);
        OneSignal.User.addEmail(this.user.email);
        OneSignal.User.pushSubscription.optIn();
        OneSignal.Notifications.addEventListener("click", (notification) => {
            console.log("click", notification);
            this.signalRService.connect2().then(async () => {
                const connectionStateSub = this.signalRService.connectionStateObs().subscribe({
                    next: async (state) => {
                        if (state === HubConnectionState.Connected) {
                            const additionalData = notification.notification.additionalData as any;
                            await this.pushReceivedSetup(additionalData);
                            connectionStateSub.unsubscribe();
                        }
                    }
                });
            }).catch((e) => {
                console.error("Error", e);
            });
        });

        OneSignal.Notifications.addEventListener("foregroundWillDisplay", (notification) => {
            console.log("foregroundWillDisplay", notification);
            this.signalRService.connect2().then(async () => {
                const connectionStateSub = this.signalRService.connectionStateObs().subscribe({
                    next: async (state) => {
                        if (state === HubConnectionState.Connected) {
                            const additionalData = notification.getNotification().additionalData as any;
                            await this.pushReceivedSetup(additionalData);
                            connectionStateSub.unsubscribe();
                        }
                    }
                });
            }).catch((e) => {
                console.error("Error", e);
            });
        });
    }

    private async pushReceivedSetup(additionalData) {
        const page = additionalData?.page as string;
        const currentPage = this.router.url;
        switch (page) {
            case "driver/information-queue":
                const raceId = additionalData?.otherData as any;
                this._crudService.getData(`Corrida/corrida-chamada/${raceId}`).subscribe(
                    async (response: ResponseAPI) => {
                        if (response?.success) {
                            const trip = response.data;
                            if (!trip)
                                return;
                            localStorage.setItem("raceRequest", JSON.stringify(trip));
                            if (!currentPage.includes(page)) {
                                await this.router.navigate([page]);
                            }
                            this.events.publish("triggerManualCaller");
                        }
                    },
                    async (error) => {
                        console.log(error);
                    }
                );
                break;
            default:
                if (!currentPage.includes(page)) {
                    await this.router.navigate([page]);
                }
                break;
        }
    }
}
